'use strict';

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _from = require('babel-runtime/core-js/array/from');

var _from2 = _interopRequireDefault(_from);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _iterator = require('babel-runtime/core-js/symbol/iterator');

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = require('babel-runtime/core-js/symbol');

var _symbol2 = _interopRequireDefault(_symbol);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = _assign2.default || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default ? "symbol" : typeof obj; };

exports.default = fetchEntity;

var _effects = require('redux-saga/effects');

var _entityKey = require('./entityKey');

var _entityKey2 = _interopRequireDefault(_entityKey);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [fetchEntity].map(_regenerator2.default.mark);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return (0, _from2.default)(arr); } }

var devMode = typeof process !== 'undefined' && process.env.NODE_ENV === 'development';

/* istanbul ignore next */
var sanitizeArgs = function sanitizeArgs(argArray) {
  if (!Array.isArray(argArray)) {
    throw new Error('argArray ' + (0, _stringify2.default)(argArray) + ' is not an array!');
  }

  return argArray.map(function (arg) {
    if (typeof arg === 'function') {
      return '*a function*';
    } else if ((typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) === 'object' && arg) {
      if (arg.constructor === Object || typeof arg.constructor === 'undefined') {
        return arg;
      }
      return '*a weird object*';
    }
    return arg;
  });
};

function fetchEntity(entity, args) {
  var _ref = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];

  var _ref$shouldThrow = _ref.shouldThrow;
  var shouldThrow = _ref$shouldThrow === undefined ? true : _ref$shouldThrow;
  var _ref$key = _ref.key;
  var key = _ref$key === undefined ? undefined : _ref$key;
  var argsObject, keyToUse, response;
  return _regenerator2.default.wrap(function fetchEntity$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          argsObject = devMode ? { args: sanitizeArgs(args) } : {};
          keyToUse = (0, _entityKey2.default)(key, entity, args);
          _context.next = 4;
          return (0, _effects.put)(entity.requestAction(_extends({}, argsObject, { key: keyToUse })));

        case 4:
          _context.prev = 4;
          _context.next = 7;
          return _effects.call.apply(undefined, [entity.promise].concat(_toConsumableArray(args)));

        case 7:
          response = _context.sent;
          _context.next = 10;
          return (0, _effects.put)(entity.successAction(_extends({ data: response }, argsObject, { key: keyToUse })));

        case 10:
          return _context.abrupt('return', response);

        case 13:
          _context.prev = 13;
          _context.t0 = _context['catch'](4);
          _context.next = 17;
          return (0, _effects.put)(entity.errorAction(_extends({
            data: _context.t0
          }, argsObject, {
            key: keyToUse
          }, shouldThrow ? {} : { error: _context.t0 })));

        case 17:
          if (!shouldThrow) {
            _context.next = 19;
            break;
          }

          throw _context.t0;

        case 19:
          return _context.abrupt('return', _context.t0);

        case 20:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[4, 13]]);
}